import { packageCategories } from '../variables/general'
import { Helmet } from 'react-helmet'
import React from 'react'
import { LINK_BASE } from 'variables/general'

function MarketplaceHelmet(props) {
  // STRUCTURED DATA TO BE INCLUDED IN GOOGLE RICH SEARCH RESULTS
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    url: 'https://app.bookfocal.com/marketplace',
    potentialAction: {
      '@type': 'SearchAction',
      target:
        'https://app.bookfocal.com/marketplace?search={search_term_string}&location={location}&category={category}&priceRange={price}',
      'query-input':
        'required name=search_term_string required name=location required name=category required name=price',
    },
    description: 'Find and book professional photographers categorized by specialty, location, and price.',
    hasOfferCatalog: {
      '@type': 'OfferCatalog',
      name: 'Photography services',
      itemListElement: [
        {
          '@type': 'ItemList',
          name: 'Photography Categories',
          itemListOrder: 'ItemListOrderAscending', // assuming ascending order based on priority
          itemListElement: [
            { '@type': 'ListItem', position: 1, item: { '@type': 'Thing', name: 'All' } },
            { '@type': 'ListItem', position: 2, item: { '@type': 'Thing', name: 'Featured' } },
            { '@type': 'ListItem', position: 3, item: { '@type': 'Thing', name: 'Headshot' } },
            { '@type': 'ListItem', position: 4, item: { '@type': 'Thing', name: 'Family' } },
            { '@type': 'ListItem', position: 5, item: { '@type': 'Thing', name: 'Newborn & Maternity' } },
            { '@type': 'ListItem', position: 6, item: { '@type': 'Thing', name: 'Wedding & Engagement' } },
            { '@type': 'ListItem', position: 7, item: { '@type': 'Thing', name: 'Portrait' } },
            { '@type': 'ListItem', position: 8, item: { '@type': 'Thing', name: 'Corporate Event' } },
            { '@type': 'ListItem', position: 9, item: { '@type': 'Thing', name: 'Boudoir' } },
            { '@type': 'ListItem', position: 10, item: { '@type': 'Thing', name: 'Product' } },
            {
              '@type': 'ListItem',
              position: 11,
              item: { '@type': 'Thing', name: 'Architecture & Real Estate' },
            },
            { '@type': 'ListItem', position: 12, item: { '@type': 'Thing', name: 'Event' } },
            { '@type': 'ListItem', position: 13, item: { '@type': 'Thing', name: 'Branding' } },
          ],
        },
      ],
    },
  }

  let titleString = `Focal | Browse ${packageCategories[props.activeCategory].name} Photographers`

  if (props.city && props.keyword) {
    titleString = `Focal | Browse ${packageCategories[props.activeCategory].name} ${
      props.keyword
    } Photographers - ${props.city}`
  } else if (props.city) {
    titleString = `Focal | Browse ${packageCategories[props.activeCategory].name} Photographers - ${
      props.city
    }`
  } else if (props.location) {
    titleString = `Focal | Browse ${packageCategories[props.activeCategory].name} ${
      props.keyword
    } Photographers`
  }
  // comment

  let descriptionString

  if (props.city && (props.keyword || props.activeCategory !== 1)) {
    descriptionString = `Find the perfect ${packageCategories[props.activeCategory].name} ${
      props.keyword
    } photography packages in ${props.city} on the Focal Marketplace.`
  } else if (props.city) {
    descriptionString = `Find the perfect ${
      packageCategories[props.activeCategory].name
    } photography packages in ${
      props.city
    } on the Focal Marketplace. Filter photo shoots by location, hours & price.`
  } else if (props.location) {
    descriptionString = `Find the perfect ${packageCategories[props.activeCategory].name} ${
      props.keyword
    } photography packages on the Focal Marketplace. Filter photo shoots by location, hours & price.`
  }

  return (
    <Helmet>
      <title>{titleString}</title>
      <script type="application/ld+json">{JSON.stringify(structuredData)}</script>
      <meta name="description" content={descriptionString} />
      <meta name="keywords" content="photographer,local,photo,book,focal,shoot,victoria" />
      {/*Open Graph*/}
      <meta
        property="og:title"
        content={
          'Focal | Browse ' + packageCategories[props.activeCategory].name + ' Photographers - Victoria BC'
        }
      />
      <meta property="og:description" content={descriptionString} />
      <meta property="og:url" content={`${LINK_BASE}${props.location.pathname}`} />
      <meta property="og:image" content="https://storage.googleapis.com/bookfocal-develop/logo.png" />
      <link rel="canonical" href="https://app.bookfocal.com/marketplace" />
    </Helmet>
  )
}

export default MarketplaceHelmet
